export default [
  {
    path: 'carneRapido/add',
    name: 'financeiroConta-carneRapido',
    component: () => import('../views/CarneRapidoFormView.vue'),
    meta: {
      title: 'Recebimento rápido de carnê',
    },
  },
];
